"use client";
import { useEffect, useRef, type ReactNode } from "react";

/** A direct example fragment opens its containing native group as well as its inline preview. */
export default function TemplateExampleGroup({ ids, count, children }: { ids: readonly string[]; count: number; children: ReactNode }) {
  const ref = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const reveal = () => {
      const id = window.location.hash.slice(1);
      if (ids.includes(id) && ref.current) { ref.current.open = true; document.getElementById(id)?.scrollIntoView({ block: "start" }); }
    };
    reveal();
    window.addEventListener("hashchange", reveal);
    return () => window.removeEventListener("hashchange", reveal);
  }, [ids]);
  return <details ref={ref} className="mt-6 rounded-xl border border-slate-200 bg-white p-5" data-example-group>
    <summary className="cursor-pointer text-lg font-semibold text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent">Explore {count} worked {count === 1 ? "example" : "examples"}</summary>
    <p className="mt-3 text-sm leading-6 text-slate-600">Illustrative situations that extend or combine workflow ideas. These are examples, not customer endorsements.</p>
    <div className="mt-5 grid gap-5 md:grid-cols-2">{children}</div>
  </details>;
}
